<div layout layout-vertical layout-full-width>
  <div class="basics">
    <rt-offer-status-indicator [offerStatus]="{ status: status(), kind: offerKind.Job }" />
    @if (showStatusTitle()) {
      <span class="title" [innerHTML]="titleHTML"></span>
    }
  </div>
  @if (description) {
    <div class="description">
      {{ description }}
    </div>
  }
</div>
